import React from "react";

function Avatar({
  src,
  size = "lg",
  userState,
  username,
  containerStyle,
  notification = null,
  widthClassName = "",
  heightClassName = "",
}) {
  let color = "";
  if (userState?.status === "online") {
    color = "primaryGreen";
  } else if (userState?.status === "oncall") {
    color = "blue";
  } else if (userState?.status === "offline") {
    color = "darkGray";
  }
  const [srcError, setSrcError] = React.useState(false);
  return (
    <div style={containerStyle} className="relative rounded-full">
      {srcError ? (
        <div
          className={`avatar-${size} rounded-full bg-primary flex justify-center items-center  ${widthClassName} ${heightClassName}`}
        >
          <span className="text-white text-lg">
            {username?.charAt(0)?.toUpperCase()}
          </span>
        </div>
      ) : (
        <div className={`avatar-${size} ${widthClassName} ${heightClassName}`}>
          <img
            alt={username}
            onError={(e) => {
              e.target.onerror = null;
              setSrcError(true);
            }}
            src={src}
            className={`avatar-${size} rounded-full ${widthClassName} ${heightClassName}`}
          />
        </div>
      )}

      {userState ? (
        <div className="bg-white absolute -bottom-1 p-0.5 right-0 h-2.5 w-2.5  my-1 rounded-full">
          <div
            style={
              color === "blue"
                ? {
                    background:
                      "linear-gradient(180deg, #716DFF 0%, #20DEFB 100%)",
                  }
                : {}
            }
            className={`h-1.5 rounded-full w-1.5 bg-${color} z-2`}
          ></div>
        </div>
      ) : undefined}
    </div>
  );
}

export default Avatar;
